import * as React from 'react';
import { Box } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import {AppBar, Container} from '@mui/material/node';
import { ProfilMenuItem } from '../profilMenuItem';
import { AppBarLogo } from '../Home/AppBarLogo';
import { useTheme } from '@mui/material/styles';

export const UserAppBar = (props) => {

  const theme = useTheme();

  return (
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" elevation={0} sx={{bgcolor: theme.palette.appBarBg.main, boxShadow: "none"}}>
          <Toolbar >
            <AppBarLogo/>
            <Container></Container>
            <ProfilMenuItem userData={props.userData}></ProfilMenuItem>
          </Toolbar>
        </AppBar>
      </Box>
    );
}